import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'light',
  align = 'left'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={['max-w-3xl', align === 'center' ? 'mx-auto text-center' : ''].join(' ')} data-id="element-282" data-mp="3k18au7gl9uk7">
      <div className={['flex items-center gap-3', align === 'center' ? 'justify-center' : ''].join(' ')} data-id="element-283" data-mp="bmgfipwzmlyl">
        <span className="h-px w-8 bg-gold-500" aria-hidden="true" data-id="element-284" data-mp="1vbylknr4r14" />
        <span className={['text-[11px] font-medium uppercase tracking-widest', isDark ? 'text-gold-400' : 'text-gold-600'].join(' ')} data-id="element-285" data-mp="6tn8twhyl3jv">
          {eyebrow}
        </span>
      </div>
      <h2 className={['mt-5 font-serif text-3xl leading-tight sm:text-[40px] sm:leading-[1.15]', isDark ? 'text-white' : 'text-navy-900'].join(' ')} data-id="element-286" data-mp="zazmn24awsp3">
        {title}
      </h2>
      {description ? <p className={['mt-5 text-base leading-relaxed', isDark ? 'text-slateink-300' : 'text-slateink-600'].join(' ')} data-id="element-287" data-mp="1o91grgsc9ihi">
          {description}
        </p> : null}
    </div>;
}